import {
  startOfMonth,
  startOfQuarter,
  startOfYear,
  subDays,
  subMonths,
  subWeeks,
} from "date-fns";
import { t } from "@/i18n-js/instance";

const i18nRoot = "date_range";

export interface RangeSelectOption {
  label: string;
  onSelect: () => [Date, Date];
  value: string;
}

export const predefinedRangePickerOptions: RangeSelectOption[] = [
  {
    label: t([i18nRoot, "last_7_days"]),
    value: "last_7_days",
    onSelect: () => [subDays(new Date(), 7), new Date()],
  },
  {
    label: t([i18nRoot, "last_4_weeks"]),
    value: "last_4_weeks",
    onSelect: () => [subWeeks(new Date(), 4), new Date()],
  },
  {
    label: t([i18nRoot, "last_3_months"]),
    value: "last_3_months",
    onSelect: () => [subMonths(new Date(), 3), new Date()],
  },
  {
    label: t([i18nRoot, "last_12_months"]),
    value: "last_12_months",
    onSelect: () => [subMonths(new Date(), 12), new Date()],
  },
  {
    label: t([i18nRoot, "month_to_date"]),
    value: "month_to_date",
    onSelect: () => [startOfMonth(new Date()), new Date()],
  },
  {
    label: t([i18nRoot, "quarter_to_date"]),
    value: "quarter_to_date",
    onSelect: () => [startOfQuarter(new Date()), new Date()],
  },
  {
    label: t([i18nRoot, "year_to_date"]),
    value: "year_to_date",
    onSelect: () => [startOfYear(new Date()), new Date()],
  },
];

export const customRangeOption: Readonly<RangeSelectOption> = {
  label: t([i18nRoot, "custom"]),
  value: "custom",
  onSelect: () => [new Date(), new Date()],
};

export const defaultPredefinedOption = predefinedRangePickerOptions[2];
